
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

@Component
export default class Email extends Vue {
  @Prop() accessibilityDescription!: string;
  @Prop() avatar?: string;
  @Prop() avatarAlt?: string;
  @Prop() avatarIntro?: string;
  @Prop() name?: string;
  @Prop() nameIntro?: string;
  @Prop() location?: string;
  @Prop() locationIntro?: string;
  @Prop() image?: string;
  @Prop() imageAlt?: string;
  @Prop() imageIntro?: string;
  @Prop({ default: 'Star' }) likeLabel?: string;
  @Prop() likeLabelIntro?: string;
  @Prop({ default: 'Comment' }) commentLabel?: string;
  @Prop() commentLabelIntro?: string;
  @Prop({ default: 'Share' }) shareLabel?: string;
  @Prop() shareLabelIntro?: string;
  @Prop() timeAgo?: string;
  @Prop() timeAgoIntro?: string;
  @Prop() showTour?: boolean;

  @Watch('showTour')
  onShowTourChanged(val: boolean, oldVal: boolean) {
    if (!oldVal && val) (this as any).$intro().start();
  }
  mounted(){
    if(this.showTour)
      (this as any).$intro().start();
    this.suppressLiveLinks();
  }
  suppressLiveLinks(){
    Array.from(document.querySelectorAll('.SocialMediaPost a')).map((link)=>{
      link.addEventListener('click',this.suppressLink);
    });
  }
  suppressLink(e:Event){
    e.preventDefault();
  }

}
